// @ts-nocheck
import PropTypes from "prop-types";
import {Fragment, useState} from "react";
import {useTranslation} from "react-i18next";
import imgBancamiga from "../../../assets/images/modal-icons/bancamiga-icon.svg";
import imgBankPlaza from "../../../assets/images/modal-icons/banco-plaza-icon.png";
import imgBankVzla from "../../../assets/images/modal-icons/bdv-icon.png";

const instructionsCls = "text-[var(--color-text)] mb-5 text-[clamp(18px,2vw,22px)] text-center font-medium";
const bankOptionsGroupCls = "flex flex-row justify-center items-center gap-6 flex-wrap max-md:gap-4";
const bankOptionCardCls =
  "w-[180px] h-[95px] rounded-2xl bg-transparent border border-transparent cursor-pointer transition-all duration-200 flex items-center justify-center shrink-0 hover:border-[var(--color-accent-magenta)] hover:bg-[var(--brand-alpha-soft)] max-md:w-[150px] max-md:h-[80px] [&_img]:max-w-[88%] [&_img]:max-h-[72%] [&_img]:object-contain [&_img]:block";
const cancelBtnWrapCls = "flex justify-center mt-8";
const cancelBtnCls =
  "h-11 px-10 rounded-full border border-[var(--color-accent-magenta)] bg-transparent text-[var(--color-accent-magenta)] text-[var(--font-body-lg)] font-semibold cursor-pointer transition-all duration-200 hover:bg-[var(--color-accent-magenta)] hover:text-[var(--color-secondary)]";

import BankBancamiga from "./BankBancamiga";
import BankPlaza from "./BankPlaza";
import BankVenezuela from "./BankVzla";

const BankOptions = ({prev}) => {
  const [bankSelected, setBankSelected] = useState("");

  const {t} = useTranslation();

  const handleBankSelect = value => {
    setBankSelected(value);
  };

  const showBackButton = bankSelected === "";

  return (
    <div>
      {bankSelected === "" && <h4 className={instructionsCls}>{t("depositInstructionsBankOptionsTitle")}</h4>}
      {bankSelected === "" && (
        <Fragment>
          <div className={bankOptionsGroupCls}>
            <div
              role="button"
              tabIndex={0}
              onClick={() => handleBankSelect("PlazBank")}
              className={bankOptionCardCls}
              onKeyDown={event => {
                if (event.key === "Enter" || event.key === " ") {
                  event.preventDefault();
                  handleBankSelect("PlazBank");
                }
              }}
            >
              <img
                src={imgBankPlaza}
                alt="Banco Plaza"
              />
            </div>

            {/* <div
              onClick={() => handleBankSelect("MiBancoBank")}
              className={bankOptionCardCls}
              onMouseEnter={() => {
                setMiBancoHover(true);
                if (hoverSoundRef.current) {
                  hoverSoundRef.current.currentTime = 0;
                  hoverSoundRef.current.play();
                }
              }}
              onMouseLeave={() => setMiBancoHover(false)}
            >
              <img
                src={miBancoHover ? imgMiBancoBlack : imgMiBanco}
                alt="Mi Banco"
              />
            </div> */}

            <div
              role="button"
              tabIndex={0}
              onClick={() => handleBankSelect("VenezuelaBank")}
              className={bankOptionCardCls}
              onKeyDown={event => {
                if (event.key === "Enter" || event.key === " ") {
                  event.preventDefault();
                  handleBankSelect("VenezuelaBank");
                }
              }}
            >
              <img
                src={imgBankVzla}
                alt="Banco de Venezuela"
              />
            </div>

            <div
              role="button"
              tabIndex={0}
              onClick={() => handleBankSelect("BancamigaBank")}
              className={bankOptionCardCls}
              onKeyDown={event => {
                if (event.key === "Enter" || event.key === " ") {
                  event.preventDefault();
                  handleBankSelect("BancamigaBank");
                }
              }}
            >
              <img
                src={imgBancamiga}
                alt="Bancamiga"
              />
            </div>
          </div>
          {showBackButton && (
            <div className={cancelBtnWrapCls}>
              <button
                type="button"
                className={cancelBtnCls}
                onClick={prev}
              >
                {t("depositInstructionsCancelBtn")}
              </button>
            </div>
          )}
        </Fragment>
      )}
      {bankSelected === "VenezuelaBank" && <BankVenezuela onBack={prev} />}
      {bankSelected === "PlazBank" && <BankPlaza onBack={prev} />}
      {bankSelected === "BancamigaBank" && <BankBancamiga onBack={prev} />}
    </div>
  );
};

BankOptions.propTypes = {
  prev: PropTypes.func,
};

export default BankOptions;
